<template>
  <div class="oil-chart" :class="{'hs-oil-chart': !horizontalScreen}">
    <div class="top-content content-all-block">
      <div class="content-title">
        <div class="xie-line"></div>
        <span>油 库</span>
        <div class="xie-line"></div>
        <div class="title-other">
          <div class="jiao"></div>
          <div class="cfx"></div>
        </div>
      </div>
      <div class="content-block">
        <div class="chart-content top-left">
          <echarts chart_id="top-left" :option="topLeftChartOption"></echarts>
        </div>
        <div class="zhong-line"></div>
        <div class="chart-content top-right">
          <echarts chart_id="top-right" :option="topRightChartOption"></echarts>
          <div class="tr-le">
            <div class="le-one" v-for="(item, index) in leDatas">
              <div class="kuai-l" :style="colors[index % 3]">
              </div>
              <span>{{item}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-bottom">
        <div></div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="content-all-block bottom-left">
        <div class="content-title">
          <div class="xie-line"></div>
          <span class="t-z">加油站</span>
          <div class="xie-line"></div>
          <div class="title-other">
            <div class="jiao"></div>
            <div class="cfx"></div>
          </div>
        </div>
        <div class="content-block title-chart-content">
          <div class="chart-title">
            <div class="title-block">
              <span>小罐多销油站</span>
            </div>
          </div>
          <div style="flex: 1">
            <echarts chart_id="bottom-left" :option="bottomLeftChartOption"></echarts>
          </div>
        </div>
        <div class="content-bottom">
          <div></div>
        </div>
        <div class="switch-map-btn">
          <div class="top-j">
          </div>
          <a href="javascript:;" class="btn-content" @click="change">
            <i class="iconfont icon-you"></i>
            切换到地图
          </a>
          <div class="bottom-j">
          </div>
        </div>
      </div>
      <div class="content-all-block bottom-right">
        <div class="content-title">
          <div class="xie-line"></div>
          <span>车辆</span>
          <div class="xie-line"></div>
          <div class="title-other">
            <div class="jiao"></div>
            <div class="cfx"></div>
          </div>
        </div>
        <div class="content-block">
          <div class="chart-content title-chart-content" style="flex: 1">
            <div class="chart-title">
              <div class="title-block">
                <span>出 车 距 离</span>
              </div>
            </div>
            <div style="flex: 1">
              <echarts chart_id="bottom-right-1" :option="bottomRightChartOption1"></echarts>
            </div>
          </div>
          <div class="chart-content title-chart-content last-chart" style="flex: 1">
            <div class="chart-title">
              <div class="title-block">
                <span>出 车 数 量</span>
              </div>
            </div>
            <div style="flex: 1">
              <echarts chart_id="bottom-right-2" :option="bottomRightChartOption2"></echarts>
            </div>
          </div>
        </div>
        <div class="content-bottom">
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GasMap from './gas_map'
import Echarts from '@/components/Echarts'
import {
  initOptionBar1,
  initOptionBar2,
  initOptionBar3,
  initOptionBar4,
  initOptionTreemap
} from '@/chartTools'
import {
  depotValume,
  gas
} from '@/api/oli_api'
import {
  listToChartData
} from '@/cllib'
export default {
  components: {
    GasMap,
    Echarts
  },
  data () {
    return {
      colors: [{
        'background-color': '#168fff'
      },
      {
        'background-color': '#65c4d7'
      },
      {
        'background-color': '#6ab4a0'
      }],
      leDatas: [],
      horizontalScreen: false,
      topLeftChartOption: initOptionBar1([], [], []),
      topRightChartOption: initOptionTreemap([], []),
      bottomLeftChartOption: initOptionBar2([], [], [], []),
      bottomRightChartOption1: initOptionBar4([], []),
      bottomRightChartOption2: initOptionBar3([], []),
      topLeftLoading: true
    }
  },
  created () {
    this.loadDatas()
    this.horizontalScreen = window.screen.width / window.screen.height > 1
  },
  methods: {
    change () {
      this.$router.push({'name': 'gas_map'})
    },
    loadDatas () {
      this.getDepotValume()
      this.getXgdxOrder()
      this.getCompanyWorkCarNum()
      this.getCompanyDistance()
    },
    getXgdxOrder () {
      let parm = {
        action: 'get_xgdx_order',
        data: ''
      }
      gas(parm).then((data) => {
        let xDatas = []
        let legends = ['平均销量', '期初库存', '入库升数']
        let chartDatas = [[], []]
        let chartDatas2 = [[]]
        data.forEach((item, index1) => {
          xDatas.push(item['加油站名称'].slice(2) + item['代号'].split('-')[1])
          legends.forEach((lItem, index) => {
            if (index === 0) {
              chartDatas2[index].push(item[lItem])
            } else {
              chartDatas[index - 1].push(item[lItem])
            }
          })
        })
        this.bottomLeftChartOption = initOptionBar2(xDatas, legends, chartDatas, chartDatas2)
      })
    },
    getDepotValume () {
      this.topLeftLoading = true
      let parm = {
        action: 'get_depot_valume',
        data: ''
      }
      depotValume(parm).then((data) => {
        data.forEach((item) => {
          item['油品'] = item['油品名称'].indexOf('汽油') > -1 ? item['油品名称'].slice(0, 2) + '#' : '柴油'
          item['油库名称'] = item['油库名称'] === '云南中石油安宁炼厂地付库' ? '安宁炼厂地付库' : item['油库名称']
        })
        let dealData = listToChartData(data, '油库名称', '油品', '指标量')
        let treemapData = []
        dealData['xDatas'].forEach((item) => {
          let total = 0
          let children = []
          dealData['legends'].forEach((itemLegend) => {
            let valueOne = dealData['dealData'][item][itemLegend]
            children.push({
              name: itemLegend,
              value: valueOne
            })
            total += valueOne
          })
          treemapData.push({
            name: item,
            value: total,
            children
          })
        })
        this.topLeftChartOption = initOptionBar1(dealData['xDatas'], dealData['legends'], dealData['chartDatas'])
        this.leDatas = dealData['xDatas'].length === 3 ? [dealData['xDatas'][1], dealData['xDatas'][0], dealData['xDatas'][2]] : dealData['xDatas']
        this.topRightChartOption = initOptionTreemap(dealData['xDatas'], treemapData)
        this.topLeftLoading = false
      })
    },
    getCompanyWorkCarNum () {
      let parm = {
        action: 'get_company_work_car_num',
        data: ''
      }
      depotValume(parm).then((data) => {
        let xDatas = []
        let chartDatas = [[]]
        data.forEach((item) => {
          let label = ['云南', '昆明'].indexOf(item['承运商'].slice(0, 2)) > -1 ? item['承运商'].slice(2) : item['承运商']
          xDatas.push(label)
          chartDatas[0].push(item['TOTAL_CAR'])
        })
        this.bottomRightChartOption2 = initOptionBar3(xDatas, chartDatas)
      })
    },
    getCompanyDistance () {
      let parm = {
        action: 'get_company_distance',
        data: ''
      }
      depotValume(parm).then((data) => {
        let xDatas = []
        let chartDatas = []
        data.forEach((item) => {
          let label = ['云南', '昆明'].indexOf(item['承运商'].slice(0, 2)) > -1 ? item['承运商'].slice(2) : item['承运商']
          xDatas.push(label)
          chartDatas.push(item['TOTAL_YJ'])
        })
        this.bottomRightChartOption1 = initOptionBar4(xDatas, chartDatas)
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
@color-oil-1: #0047b2;
@color-oil-2: #8ddbea;
.bottom-left {
  flex: 9;
  position: relative;
}
.chart-title {
  width: 100%;
  height: 5rem;
  min-height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .title-block {
    width: 6.5rem;
    height: 1.4rem;
    border: 1px solid #168fff;
    text-align: center;
    border-radius: 0.4rem;
    background-color: rgba(22, 143, 255, 0.2);
    span {
      line-height: 1.6rem;
      color: #84fbc2;
      font-size: 0.8rem;
    }
  }
}
.bottom-right {
  margin-left: 0.8rem;
  flex: 11;
}
.zhong-line {
  margin: 1rem 0;
  width: 1px;
  background-color: #bbb;
}
.tr-le {
  position: absolute;
  bottom: 0;
  right: 3rem;
  left: 3rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
}
.le-one {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  span {
    color: #fff;
  }
}
.kuai-l {
  width: 1.5rem;
  height: 0.9rem;
  border-radius: 0.2rem;
  margin-right: 0.4rem;
}
.top-left {
  flex: 12;
}
.top-right {
  flex: 13;
  padding-bottom: 1rem;
  position: relative;
}
.content-btm-left {
  flex: 5;
}
.content-btm-right {
  flex: 3;
}
.content-bottom {
  border-right:1px solid @color-oil-1;
  div {
    margin: 0;
    width: 0;
    height: 0;
    border-bottom: 1rem solid @color-oil-1;
    border-right: 1rem solid transparent;
  }
}
.title-chart-content {
  display: flex;
  flex-direction: column;
}
.content-block {
  flex: 1;
  border-right:1px solid @color-oil-1;
  border-left:1px solid @color-oil-1;
  display: flex;
}
.content-title {
  min-height: 1.5rem;
  display: flex;
  .t-z {
    letter-spacing: 0.2rem;
    margin:0 0.8rem 0 1rem;
  }
  span {
    font-size: 1.2rem;
    line-height: 1;
    color: @color-oil-2;
    margin:0 0.3rem 0 1rem;
    letter-spacing: 0.7rem;
  }
  .xie-line {
    min-height: 1rem;
    margin-top: 0.5rem;
    width: 1.25rem;
    background: linear-gradient(-40deg, rgba(0,0,0,0) 47.9%, @color-oil-1 48% ,@color-oil-1 52%, rgba(0,0,0,0) 52.1%);
  }
  .title-other {
    margin-top: 0.5rem;
    flex: 1;
    border-top:1px solid @color-oil-1;
    border-right:1px solid @color-oil-1;
    display: flex;
    justify-content: flex-end;
    .jiao {
      margin: 0;
      width: 0;
      height: 0;
      border-right: 0.625rem solid @color-oil-1;
      border-bottom: 0.625rem solid transparent;
    }
    .cfx {
      width: 2.38rem;
      height: 0.625rem;
      background-color: @color-oil-1;
    }
  }
}
.content-all-block {
  display: flex;
  flex-direction: column;
  border-bottom:1px solid @color-oil-1;
}
.oil-chart {
  flex: 1;
  padding: 2rem 1rem 1rem 2rem;
  background: url('~assets/oil_chart_bk.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  flex-direction:column;
}
.top-content {
  flex: 4;
  margin-bottom: 0.8rem;
}
.bottom-content {
  flex: 7;
  display: flex;
}
.hs-oil-chart {
  padding: 0.2rem;
  overflow: auto;
  display: block;
  font-size: 14px;
  .zhong-line {
    display: none;
  }
  .last-chart {
    margin-top: 2rem;
  }
  .chart-title {
    margin-top: 1rem;
  }
  .content-block {
    flex-direction: column;
    height: 40rem;
    min-height: 40rem;
  }
  .content-all-block {
    flex-direction: column;
    margin-top: 1.5rem;
  }
  .bottom-content {
    flex-direction: column;
  }
  .bottom-right {
    margin: 1.5rem 0 0 0;
  }
  .top-content {
    margin-bottom: 0;
  }
}
.switch-map-btn {
  z-index: 20;
  position: absolute;
  display: flex;
  top: 7rem;
  right: 0;
  width: 1.3rem;
  flex-direction:column;
  line-height: 1.1;
}
.icon-qiehuan3:before { content: "\e61d"; }
.top-j {
  flex: 1;
  width: 0;
  height: 0;
  border-bottom: 0.6rem solid @color-oil-1;
  border-left: 1.3rem solid transparent; 
}
.bottom-j {
  flex: 1;
  width: 0;
  height: 0;
  border-top: 0.6rem solid @color-oil-1;
  border-left: 1.3rem solid transparent; 
}
.btn-content {
  padding: 3px 0;
  background-color: @color-oil-1;
  text-align: center;
  color: #fff;
  font-size: 0.75rem;
  i {
    line-height: 1.3;
    font-size: 1rem;
  }
}
</style>

<style scoped lang="less">
.echarts-block {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// oil_chart.vue?1d297dd4